import queryString from "query-string";

import { urlUpdate } from "../urlUpdate";

type UpdateQueryParamsProps = {
  queryParams: {
    key: string;
    value?: string | number | null;
  }[];
  returnUrl?: boolean;
  usePushState?: boolean;
};

export const updateQueryParams = ({
  queryParams,
  returnUrl = false,
  usePushState = false,
}: UpdateQueryParamsProps) => {
  const searchParams = new URLSearchParams(globalThis.location.search);
  queryParams.forEach(({ key, value }) => {
    if (value === undefined || value === null || value === "") {
      searchParams.delete(key);
    } else {
      searchParams.set(key, value.toString());
    }
  });
  if (returnUrl) {
    return searchParams.toString();
  } else {
    urlUpdate({
      queryObject: queryString.parse(searchParams.toString()),
      usePushState,
    });
  }
};
